import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/safe-driving-vDSP/SafeDrivingDailyGraph/.eu';
import Kr from '@di-shared/features/safe-driving-vDSP/SafeDrivingDailyGraph/.kr';

export interface SafeDrivingDailyGraphProps {
  data: Array<{
    score: number;
    scoreDate: Date | null;
  }>;
}

export default function SafeDrivingDailyGraph(props: SafeDrivingDailyGraphProps) {
  return (
    <>
      <Environment.Kr>
        <Kr {...props} />
      </Environment.Kr>
      <Environment.Eu>
        <Eu {...props} />
      </Environment.Eu>
    </>
  );
}
